import { apiCall } from './generated/gqlClient';

const generatePaymentIntentApiRequest = async ({ reservationId, subscriptionId, productId, membershipId, email }) => {
  const query = `
    query generatePaymentIntent($productId: Int, $reservationId: Int, $subscriptionId: Int, $email: String, $membershipId: Int) {
      generatePaymentIntent(
        productId: $productId
        reservationId: $reservationId
        subscriptionId: $subscriptionId
        email: $email
        membershipId: $membershipId
      ) {
        id
        message
        success
        amount
        amountCents
        clientSecret
        stripeAccount
      }
    }
  `;
  return apiCall({ query, variables: { reservationId, subscriptionId, productId, membershipId, email } });
};

export { generatePaymentIntentApiRequest };
